

const settings = {
    version : "0.0.14dev",
    messages : {
        error_page : {
            title : `Sorry, something went wrong!`,
            message : `We are in the early stages of this project, please send us feedback on how to reproduce this error ( if possible include the file imported )`
        }
    },
    svg_prefix : "https://cdn.jsdelivr.net/npm/sbolviewer@0.0.11/sbolglyph"
    // svg_prefix : "/sbolglyph"
}
export default settings